import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PageIndex  } from "../../models";
import { successfulLogin } from "../../auth/authDataSlice";
import { MarketFilter } from "./types"
type OrderPageState = {
	filter: MarketFilter;
	index: PageIndex;
};

export const initialState: OrderPageState = {
	index: {
		itemsPerPage: 10,
		pageNumber: 0,
	},	
	filter: { sort: 0 },
};

const name = "marketData";

const marketDataSlice = createSlice({
	name,
	initialState,
	reducers: {
		setFilter: (state, action: PayloadAction<MarketFilter>) => ({
			...state,
			filter: action.payload,
		}),
		setIndex: (state, action: PayloadAction<PageIndex>) => ({
			...state,
			index: action.payload,
		})
	},
	extraReducers: builder => {
		builder.addCase(successfulLogin, state => ({
			...state,
			index: {
				itemsPerPage: state.index.itemsPerPage,
				pageNumber: initialState.index.pageNumber,
			},
		}));
	},
});

export const { setFilter, setIndex } = marketDataSlice.actions;

export default marketDataSlice.reducer;
